export default {
  list: {},
  loaded: false,
};
